<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-truck" titulo="CADASTRO DE TRANSPORTADORA">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="registro.NOME" class="mx-2">•</span>
            <span v-if="registro.NOME" class="mr-2">
              {{registro.NOME.substring(0,50)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Informações Básicas -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Básicas</h6>
                  <small class="text-muted">Dados principais da transportadora</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="2">
                <label class="modal-label-premium">Código</label>
                <b-form-input 
                  type="text" 
                  :value="registro.CODIGO || 'Novo'" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Tipo *</label>
                <b-form-select 
                  v-model="registro.OP_TIPO_CNPJ" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !registro.OP_TIPO_CNPJ}">
                  <b-form-select-option value="C">CNPJ</b-form-select-option>
                  <b-form-select-option value="F">CPF</b-form-select-option>
                </b-form-select>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">CPF/CNPJ *</label>
                <the-mask 
                  class="form-control rounded-pill shadow-xs" 
                  :mask="registro.OP_TIPO_CNPJ === 'F' ? '###.###.###-##' : '##.###.###/####-##'" 
                  placeholder="000.000.000-00 ou 00.000.000/0000-00" 
                  v-model="registro.CGC"
                  :class="{'is-invalid': !registro.CGC}"
                  ref="edCGC">
                </the-mask>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Status *</label>
                <b-form-select 
                  v-model="registro.STATUS" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !registro.STATUS}">
                  <b-form-select-option value="1">Ativo</b-form-select-option>
                  <b-form-select-option value="0">Inativo</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Nome/Razão Social *</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.NOME" 
                  maxlength="200" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !registro.NOME}"
                  placeholder="Informe o nome ou razão social"
                  ref="edNome">
                </b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Resumido</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.RESUMIDO" 
                  maxlength="30" 
                  class="rounded-pill shadow-xs"
                  placeholder="Nome resumido">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <label class="modal-label-premium">Inscrição Estadual</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.IE" 
                  maxlength="15" 
                  class="rounded-pill shadow-xs"
                  placeholder="I.E.">
                </b-form-input>
              </b-col>
              <b-col sm="3" class="d-flex align-items-end">
                <b-form-checkbox 
                  v-model="registro.OP_ISENTO_ICMS" 
                  value="1" 
                  unchecked-value="0"
                  class="mt-3">
                  Isento de ICMS
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-card>

          <!-- Endereço -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Endereço</h6>
                  <small class="text-muted">Localização da transportadora</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Logradouro</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.ENDERECO" 
                  maxlength="70" 
                  class="rounded-pill shadow-xs"
                  placeholder="Rua, Avenida, etc.">
                </b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Bairro</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.BAIRRO" 
                  maxlength="50" 
                  class="rounded-pill shadow-xs"
                  placeholder="Bairro">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="2">
                <label class="modal-label-premium">UF</label>
                <b-form-select 
                  v-model="registro.ID_UF" 
                  :options="estados" 
                  value-field="ID" 
                  text-field="ID" 
                  class="rounded-pill shadow-xs">
                  <template #first>
                    <b-form-select-option :value="null">UF</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col sm="6">
                <label class="modal-label-premium">Município</label>
                <div class="d-flex align-items-center">
                  <b-form-select 
                    v-model="registro.ID_MUNICIPIO" 
                    :options="municipios" 
                    :disabled="municipiosBusy || !registro.ID_UF" 
                    value-field="ID" 
                    text-field="NOME" 
                    class="rounded-pill shadow-xs flex-grow-1">
                    <template #first>
                      <b-form-select-option :value="null">Selecione um município</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-spinner v-if="municipiosBusy" small class="ml-2 text-primary"></b-spinner>
                </div>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">CEP</label>
                <the-mask 
                  class="form-control rounded-pill shadow-xs" 
                  mask="#####-###" 
                  placeholder="00000-000" 
                  v-model="registro.CEP">
                </the-mask>
              </b-col>
            </b-row>
          </b-card>

          <!-- Contato -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-phone"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Dados de Contato</h6>
                  <small class="text-muted">Telefones e contatos</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="4">
                <label class="modal-label-premium">Telefone</label>
                <the-mask 
                  class="form-control rounded-pill shadow-xs" 
                  mask="(##) ####-####" 
                  placeholder="(00) 0000-0000" 
                  v-model="registro.TEL">
                </the-mask>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Fax</label>
                <the-mask 
                  class="form-control rounded-pill shadow-xs" 
                  mask="(##) ####-####" 
                  placeholder="(00) 0000-0000" 
                  v-model="registro.FAX">
                </the-mask>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Contato</label>
                <b-form-input 
                  type="text" 
                  v-model="registro.CONTATO" 
                  maxlength="40" 
                  class="rounded-pill shadow-xs"
                  placeholder="Nome do contato">
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>

          <!-- Observações -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-comment"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Observações</h6>
                  <small class="text-muted">Informações adicionais</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="12" class="mb-3">
                <label class="modal-label-premium">Observação</label>
                <b-form-textarea 
                  v-model="registro.OBS" 
                  rows="4"
                  maxlength="500"
                  class="rounded shadow-xs"
                  placeholder="Informe observações adicionais (opcional)">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import {TheMask} from 'vue-the-mask'

export default {
  components: {
    HeaderPadrao,
    TheMask
  },
  data() {
    return {
      registro: {
        CODIGO: null,
        NOME: '',
        RESUMIDO: '',
        ENDERECO: '',
        BAIRRO: '',
        CIDADE: '',
        UF: '',
        CGC: '',
        TEL: '',
        FAX: '',
        CEP: '',
        CONTATO: '',
        STATUS: '1',
        IE: '',
        OP_TIPO_CNPJ: 'C',
        OP_ISENTO_ICMS: '0',
        ID_MUNICIPIO: null,
        ID_UF: null,
        OBS: ''
      },
      estados: [],
      municipios: [],
      municipiosBusy: false
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },

  watch: {
    'registro.ID_UF': async function () {
      await this.getMunicipios()
    },
    'registro.ID_MUNICIPIO': function(val) {
      if (val && this.municipios.length > 0) {
        const municipio = this.municipios.find(m => m.ID === val)
        if (municipio) {
          this.registro.CIDADE = municipio.NOME
        }
      }
    },
    'registro.OP_TIPO_CNPJ': function() {
      // Limpa o CGC quando muda o tipo
      this.registro.CGC = ''
    }
  },

  methods: {
    voltar() {
      this.$router.push('/cadastros/transportadora')
    },

    getUsuarioLogado() {
      return window.localStorage.getItem('login') || 'Sistema'
    },
    
    async carregar(id) {
       this.$store.commit('controle/setAguardando', true)
       try {
           const response = await this.$http.get(`/api/protected/transportadora/getById/${id}`)
           
           if (Array.isArray(response.data) && response.data.length > 0) {
              const item = response.data[0]
              this.registro = { ...this.registro, ...item }
              
              // Se não tem OP_TIPO_CNPJ definido, tenta inferir pelo tamanho do CGC
              if (!this.registro.OP_TIPO_CNPJ && this.registro.CGC) {
                const numeros = this.registro.CGC.replace(/\D/g, '')
                this.registro.OP_TIPO_CNPJ = numeros.length === 11 ? 'F' : 'C'
              }
              
              // Garante valores padrão
              if (!this.registro.STATUS) this.registro.STATUS = '1'
              if (!this.registro.OP_ISENTO_ICMS) this.registro.OP_ISENTO_ICMS = '0'
              if (!this.registro.OP_TIPO_CNPJ) this.registro.OP_TIPO_CNPJ = 'C'
              
           } else {
               this.$bvToast.toast('Registro não encontrado', { variant: 'warning' })
               this.voltar()
           }

       } catch (err) {
           console.error('Erro ao carregar', err)
           this.$bvToast.toast('Erro ao carregar dados', { variant: 'danger' })
       } finally {
            this.$store.commit('controle/setAguardando', false)
       }
    },

    async gravar() {
        // Validações
        if (!this.registro.NOME || this.registro.NOME.trim() === '') {
            this.$bvToast.toast('Informe o Nome/Razão Social', { variant: 'warning' })
            if (this.$refs.edNome) {
              this.$refs.edNome.focus()
            }
            return
        }

        if (!this.registro.CGC || this.registro.CGC.trim() === '') {
            this.$bvToast.toast('Informe o CPF/CNPJ', { variant: 'warning' })
            if (this.$refs.edCGC) {
              this.$refs.edCGC.$el.focus()
            }
            return
        }

        if (!this.registro.STATUS) {
            this.$bvToast.toast('Informe o Status', { variant: 'warning' })
            return
        }

        if (!this.registro.OP_TIPO_CNPJ) {
            this.$bvToast.toast('Informe o Tipo (CPF/CNPJ)', { variant: 'warning' })
            return
        }

        // Sincronizar UF se ID_UF foi preenchido
        if (this.registro.ID_UF) {
          this.registro.UF = this.registro.ID_UF
        }

        try {
            const body = {
                registro: {
                  ...this.registro
                },
                login: window.localStorage.getItem('login') || 'sistema'
            }
            
            const isNovo = !this.registro.CODIGO
            let url = '/api/protected/transportadora/post'
            if (!isNovo) {
                url = '/api/protected/transportadora/edit'
            }

            const res = await this.$http.post(url, body)

            // Captura o ID do registro salvo para selecionar na listagem
            let idSalvo = null
            
            if (isNovo) {
              // Para novos registros, tenta múltiplas possibilidades
              idSalvo = res.data?.CODIGO || 
                       res.data?.codigo || 
                       res.data?.insertId || 
                       res.data?.registro?.CODIGO ||
                       res.data?.registro?.codigo ||
                       null
            } else {
              idSalvo = this.registro.CODIGO
            }
            
            if (idSalvo) {
              this.$store.commit('transportadora/SET_REGISTRO_SELECIONADO_ID', idSalvo)
            }
            this.$store.commit('transportadora/SET_RECARREGAR_LISTA', true)

            this.$bvToast.toast('Registro salvo com sucesso', { variant: 'success' })
            this.voltar()

        } catch (err) {
             console.error('Erro ao gravar', err)
             this.$bvToast.toast('Erro ao salvar registro', { title: 'Erro', variant: 'danger' })
        }
    },

    async getEstados() {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
      } catch(err) {
        this.estados = []
        console.error('Erro ao carregar estados:', err)
      }
    },

    async getMunicipios() {
      this.municipiosBusy = true
      this.municipios = []
      
      if (this.registro.ID_UF) {
        try {
          let result = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios = result.data
        } catch(err) {
          console.error('Erro ao carregar municípios:', err)
        }
      }
      
      this.municipiosBusy = false
    }
  },
  
  async created() {
      await this.getEstados()
      
      const id = this.$route.params.id
      if (id) {
          await this.carregar(id)
      }
  },
  
  mounted() {
      this.$nextTick(() => {
          // Focus no campo de nome
          if (this.$refs.edNome && !this.registro.CODIGO) {
            this.$refs.edNome.focus()
          }
      })
  }

}
</script>

<style scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.modal-label-premium {
    font-size: 0.8rem;
    font-weight: 700;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/transportadora/TransportadoraCadastro.vue